import { Helmet } from 'react-helmet';
import I18njs from 'i18n-js';

import DashboardContainer from '../DashboardContainer';
import Timesheets from './Timesheets';

const TimesheetsContainer = () => {
  return (
    <DashboardContainer showSecondaryNav>
      <Helmet>
        <title>{I18njs.t('helmet.Timesheets')}</title>
      </Helmet>
      <Timesheets />
    </DashboardContainer>
  );
};

export default TimesheetsContainer;
